import { ReactElement, useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

import api from 'config/api';
import Converter from 'lib/Converter';
import Http from 'lib/Http';
import Storage from 'lib/Storage';
import { Indicator } from 'types/indicator';
import { isNotUndefined } from 'utils/type-checker';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

// This schema is used to validate the enter form.
const schema = yup.object().shape({
  email: yup
    .string()
    .email("Ups! it's not a valid email address")
    .required('Please provide your email address'),
  password: yup.string().required('Please fill your password'),
});

type Credentials = {
  email: string;
  password: string;
};

function Enter(props: any): ReactElement<HTMLDivElement> {
  const [status, setStatus] = useState<Indicator>('idle');
  const {
    formState: { errors },
    handleSubmit,
    register,
    setError,
  } = useForm<Credentials>({
    resolver: yupResolver(schema),
  });

  let storage = new Storage();
  let history = useHistory();

  // Call this callback when the user submit the form. The callback will send
  // the credentials via API.
  const onSubmit: SubmitHandler<Credentials> = async (form) => {
    setStatus('loading');

    Http.headers({
      Accept: 'application/json',
    })
      .method('POST')
      .body(Converter.toJson(form));

    let res = await Http.send(api.enter);
    let json = await res.json();

    // Handle if account not found.
    if (res.status === 422) {
      setStatus('error');
      if (isNotUndefined(json.errors)) {
        for (let [field, errorMessages] of Object.entries(json.errors)) {
          setError(field as any, {
            type: 'manual',
            message: (errorMessages as string[]).join(' '),
          });
        }
      }
      return;
    }

    storage.put('token', json.data.token);
    history.push('/a/dashboard');
    return;
  };

  return (
    <div className="mx-auto py-20 max-w-3xl">
      <h1 className="mb-28 text-3xl font-display">
        Yo! Welcome back, <span className="text-primary">thor.</span>
      </h1>
      <div className="h-full grid grid-cols-2 gap-x-10">
        <form onSubmit={handleSubmit(onSubmit)}>
          {status === 'error' && (
            <p className="mb-5 px-5 py-2 bg-red-100 text-sm text-primary font-body">
              Ups! your credentials does not match
            </p>
          )}
          <div className="mb-5 last:mb-0">
            <label
              className="mb-1 inline-block text-secondary text-sm font-display"
              htmlFor="email"
            >
              Email
            </label>
            <input
              className="py-3 px-5 w-full bg-gray-200 rounded-lg text-sm focus:outline-none"
              type="email"
              id="email"
              {...register('email')}
            />
            {errors.email?.message && (
              <span className="text-xs text-primary font-body">
                {errors.email.message}
              </span>
            )}
          </div>
          <div className="mb-5 last:mb-0">
            <label
              className="mb-1 inline-block text-secondary text-sm font-display"
              htmlFor="password"
            >
              Password
            </label>
            <input
              className="py-3 px-5 w-full bg-gray-200 rounded-lg text-sm focus:outline-none"
              type="password"
              id="password"
              {...register('password')}
            />
            {errors.password?.message && (
              <span className="text-xs text-primary font-body">
                {errors.password.message}
              </span>
            )}
          </div>
          <div>
            <button className="py-3 w-full bg-primary flex flex-row justify-center text-white font-display hover:bg-secondary">
              {status === 'loading' ? 'BRING YOU IN...' : 'BRING ME IN'}
            </button>
          </div>
        </form>
        <div>
          <img
            src="https://res.cloudinary.com/trycatch/image/upload/v1627584602/thexdev/common/ui_illustration_nope_api_wjodpf.svg"
            alt="nope api illustration"
          />
        </div>
      </div>
    </div>
  );
}

export default Enter;
